/**
 * Feature Flags Configuration
 *
 * This file contains feature flags that can be used to enable/disable
 * specific features across the application.
 *
 * @typedef {Object} FeatureFlags
 * @property {boolean} blogEnabled - Controls whether blog functionality is available
 */

export const FEATURE_FLAGS = {
  // Blog feature toggle - set to false to disable all blog functionality
  blogEnabled: false

  // Add more feature flags here as needed
  // Example:
  // groceryEnabled: true,
  // chatEnabled: true,
};

/**
 * Check if a feature is enabled
 * @param {string} featureName - The name of the feature flag
 * @returns {boolean} - Whether the feature is enabled
 */
export const isFeatureEnabled = (featureName) => {
  return FEATURE_FLAGS[featureName] ?? false;
};
